export default function RecipeDirections({ title, steps = [] }) {
  if (!steps.length) return null;

  return (
    <section className="py-8 px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-6 text-primary-red">
          {title || 'Directions'}
        </h2>
        <ol className="space-y-4 list-decimal list-inside text-gray-700 leading-relaxed">
          {steps.map((step, idx) => (
            <li key={idx}>{step}</li>
          ))}
        </ol>
      </div>
    </section>
  );
}
